import { createContext } from 'react'

const FlagContext = createContext({})

export default FlagContext
